import React from "react";
import { Link } from "react-router-dom";
import { Gift, CalendarCheck, Wallet, MessageSquare, ArrowRight, Check } from "lucide-react";

const PERKS = [
  [CalendarCheck, "Rezervasyon ve ajanda takibi"],
  [Wallet, "Gelir-gider ve ön muhasebe"],
  [MessageSquare, "Müşterilere otomatik SMS hatırlatma"],
];

export const BasitajandaGift = () => (
  <section className="max-w-7xl mx-auto px-5 pb-20" data-testid="basitajanda-gift">
    <div className="relative overflow-hidden rounded-3xl bg-[#2A2224] text-white">
      <div className="absolute -top-24 -right-24 w-80 h-80 rounded-full bg-[#C15B6B]/25 blur-3xl" />
      <div className="absolute -bottom-28 -left-16 w-72 h-72 rounded-full bg-[#C6A15B]/20 blur-3xl" />
      <div className="relative grid lg:grid-cols-[1.2fr_1fr] gap-10 p-8 md:p-12 items-center">
        <div>
          <span className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-[#C6A15B]/15 text-[#E9CF95] text-xs font-semibold tracking-[0.15em] uppercase">
            <Gift className="w-3.5 h-3.5" /> Firmalara Özel Hediye
          </span>
          <h2 className="font-display text-3xl md:text-4xl font-bold mt-4 leading-tight">
            DüğünSenin'e üye ol, <span className="text-[#E9CF95]">Basitajanda 1 yıl Premium</span> bizden hediye
          </h2>
          <p className="text-white/70 mt-4 max-w-xl text-sm md:text-base">
            İşletmenizi DüğünSenin'e ücretsiz kaydedin. Düğün ve etkinlik firmalarının işini kolaylaştıran Basitajanda'nın 1 yıllık Premium paketini ücretsiz kullanın.
          </p>
          <ul className="mt-6 space-y-2.5">
            {PERKS.map(([Icon, t]) => (
              <li key={t} className="flex items-center gap-3 text-sm text-white/85">
                <span className="w-7 h-7 rounded-lg bg-white/10 flex items-center justify-center"><Icon className="w-4 h-4 text-[#E9CF95]" /></span>{t}
              </li>
            ))}
          </ul>
          <div className="flex flex-wrap gap-3 mt-8">
            <Link to="/firma-kayit" data-testid="basitajanda-gift-register" className="inline-flex items-center gap-2 px-6 h-12 rounded-full bg-gradient-to-r from-[#C15B6B] to-[#9E2A3B] text-white font-medium hover:-translate-y-0.5 transition-transform">
              Ücretsiz Firma Kaydı <ArrowRight className="w-4 h-4" />
            </Link>
          </div>
        </div>
        <div className="rounded-2xl bg-white/5 border border-white/10 backdrop-blur-md p-7">
          <img src="/partners/basitajanda.svg" alt="Basitajanda" className="h-9 w-auto" data-testid="basitajanda-logo" />
          <div className="mt-6 flex items-end gap-2">
            <span className="font-display text-5xl font-bold text-[#E9CF95]">1 Yıl</span>
            <span className="text-white/70 mb-1.5">Premium paket</span>
          </div>
          <p className="text-white/50 text-sm mt-1"><span className="line-through">₺3.990</span> → <span className="text-white font-semibold">Ücretsiz</span></p>
          <ol className="mt-6 space-y-3 text-sm text-white/80">
            {["DüğünSenin'e ücretsiz firma kaydı yapın", "Aynı telefonla basitajanda.com'a kaydolun", "1 yıllık Premium paketiniz tanımlansın"].map((t, i) => (
              <li key={t} className="flex gap-3"><span className="w-6 h-6 rounded-full bg-[#C6A15B] text-[#2A2224] text-xs font-bold flex items-center justify-center shrink-0">{i + 1}</span>{t}</li>
            ))}
          </ol>
          <p className="mt-5 flex items-center gap-2 text-xs text-white/50"><Check className="w-3.5 h-3.5" /> Kredi kartı gerekmez</p>
        </div>
      </div>
    </div>
  </section>
);
